import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProjectDetails } from '@/app/interfaces/project';
import { ReviewFieldsService } from '@/app/services/ia-services/review-fields.service';
import { ReviewFieldKey } from '@/app/interfaces/review-fields.types';
import { TooltipComponent } from '@/app/shared/tooltip/tooltip.component';
import { mapRiskLevelLabel } from '@/app/shared/mappers/risk-level-label.mapper';
import { RiskLevelClassPipe } from '../../../../../pipe/riskLevelClass.pipe';

@Component({
  selector: 'app-project-risk-data',
  standalone: true,
  imports: [CommonModule, TooltipComponent, RiskLevelClassPipe],
  templateUrl: './project-risk-data.component.html',
})
export class ProjectRiskDataComponent {
  @Input() project: ProjectDetails | null = null;
  @Input() reviewMode = false;
  @Input() readonlyReview = false;
  @Input() showPreviousReviewIndicators = false;

  constructor(public reviewFields: ReviewFieldsService) {}

  previousReviewText(fieldKey: ReviewFieldKey): string {
    return this.reviewFields.getPreviousReviewTooltipText(fieldKey);
  }

  riskLevelLabel(value: string | null | undefined): string {
    return mapRiskLevelLabel(value);
  }
}
